// Configuration de l'application
export const APP_CONFIG = {
  name: 'Thomas Prêtre Photography',
  photographer: 'Thomas Prêtre',
  email: 'thomas.pretre.pro@gmail.com',
  instagram: 'https://www.instagram.com/tom_p_pics/',
  description: 'Photographe amateur spécialisé en portraits, paysages et concerts. Découvrez mes galeries et contactez-moi pour vos projets photographiques.'
};

// Catégories d'albums
export const ALBUM_CATEGORIES = {
  portraits: 'Portraits',
  landscape: 'Paysages',
  concerts: 'Concerts',
  events: 'Événements',
  essais: 'Essais',
  animaux: 'Animaux'
};